export default __webpack_public_path__ + "static/media/pin.e369ae03.png";